export default __webpack_public_path__ + "static/media/mh-bedroom-2nd-shower-room-01.43474772.jpg";